define(
    'modules/newscollection',[
        'jquery',

        'utils/toast',
        'utils/translate',

        'server-settings'
    ],

    function ($, Toast, t, serversettings) {

        function NewsCollection() { }

        NewsCollection.prototype.news = [];

        NewsCollection.prototype.offset = 8;

        NewsCollection.prototype.moreNewsAvailable = true;

        NewsCollection.prototype.syncing = false;

        NewsCollection.prototype.listLoaded = false;

        NewsCollection.prototype.setNumberToLoad = function (n) {
            this.limit = n;
        };

        NewsCollection.prototype.loadAdditional = function () {
            var self = this;
            this.syncing = false;            
            this.listLoaded = false;


            if (this.limit === undefined) throw 'You need to set a load limit';

            $.getJSON(serversettings.newsListApiUrl, {
                offset: this.offset,
                limit: this.limit
            }).success(function (news) {
                self.syncing = true;
                if(news.newsitems.length < self.limit){
                    $('#load-news').hide();
                }
                $.each(news.newsitems, function () {
                    self.news.push(this);
                });

                self.offset += news.newsitems.length;
                self.listLoaded = true;
            }).fail(function () {
                self.syncing = false;
                Toast.queueError(t('Failed to load news'));
            });
        };

        NewsCollection.prototype.reload = function () {
            this.offset = 0;
            this.news.newsitems.splice(0, this.news.length);
            this.loadAdditional();
        };

        return NewsCollection;
    }
);
